import Command from './Command';

import SpeechBalloonResource from '../resources/SpeechBalloonResource';
import VoiceResource from '../resources/VoiceResource';
import SoundResource from '../resources/SoundResource';

import SpeechTextCommandOptions from '../../value_objects/command_options/SpeechTextCommandOptions';
import SoundEffectCommandOptions from '../../value_objects/command_options/SoundEffectCommandOptions';

export default class SpeechTextShowCommand extends Command {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    public id: number,
    public sceneId: number,
    public speechBalloon: SpeechBalloonResource,
    public text: string,
    public voice: VoiceResource | null,
    public sound: SoundResource | undefined | null,
    public options: SpeechTextCommandOptions,
    public soundOptions: SoundEffectCommandOptions,
  ) {
    super(id, sceneId);
  }

  public getAudioUrl(): string | null {
    if (!this.sound) {
      return null;
    }
    return this.sound.getAudioUrl({
      satrtTime: this.soundOptions.startTime,
      endTime: this.soundOptions.endTime,
    });
  }
}
